module.exports = __webpack_public_path__ + "static/media/nombres.22669652.svg";